var PagingView = ViewModel.extend({

    initialize: function () {
    },

    template: _.template($('#pagingtemplate').html().trim()),

    render: function () {
        PagingView.__super__.render.apply(this, arguments);

        var config = module.config();
        $("#content-pagination-top ul li a, #content-pagination-bottom ul li a").click(function (e) {
            e.preventDefault();
            var page = $(this).data("page");
            if (page) {
                if (!ym.BaseValues.defaultSearchMode || ym.BaseValues.defaultSearchMode == "area") {
                    Search.searchInAreaByBranchCode(config.BranchCodes, {
                        ZoomLevel: 11,
                        SingleSlotGeo: config.SingleSlotGeo,
                        LocX: config.LocX,
                        LocY: config.LocY,
                        Page: page,
                        Top: config.Top
                    });
                } else {
                    Search.searchAtLocationByBranchCode(config.BranchCodes, {
                        ZoomLevel: 11,
                        SingleSlotGeo: config.SingleSlotGeo,
                        LocX: config.LocX,
                        LocY: config.LocY,
                        MaxRadius: -1,
                        Page: page,
                        Top: config.Top
                    });
                }
            }
        });
        return this;
    }
});